import React, { useContext } from 'react';
import { Pressable } from 'react-native';

import AuthContext from 'app/src/contexts/AuthContext';
import { Text } from 'app/src/styles';

const CopyDirectLink = ({ txn, developerOnly }) => {
  const { role } = useContext(AuthContext);

  const directLink =
    window.location.origin + '/accounting/transactions/' + txn.id;

  const isDeveloper = 'Developer' === role;

  const copyLinkToClipboard = () => {
    navigator.clipboard.writeText(directLink);
  };

  if (developerOnly && !isDeveloper) {
    return null;
  }

  return (
    <Pressable onPress={copyLinkToClipboard}>
      <Text>Copy Direct Link{isDeveloper ? ` ${txn.id}` : ''}</Text>
    </Pressable>
  );
};

export default CopyDirectLink;
